import type {DependenciesSingleton} from 'framework';
import {createContext} from 'react';

export const DependenciesContext = createContext<DependenciesSingleton | null>(null);

export const DependenciesProvider = DependenciesContext.Provider;
